const STORAGE_KEY = 'quickJoinNameSetup';

export const markQuickJoinNameSetupRequired = (user, roomId = null) => {
  if (!user?.id) {
    return;
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    userId: user.id,
    roomId,
    required: true,
    dismissed: false,
  }));
};

export const getQuickJoinNameSetupState = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
  } catch (_error) {
    return null;
  }
};

export const shouldPromptQuickJoinNameSetup = (user) => {
  const state = getQuickJoinNameSetupState();

  return Boolean(
    user?.id &&
    state?.required &&
    !state?.dismissed &&
    Number(state.userId) === Number(user.id)
  );
};

export const dismissQuickJoinNameSetup = (user) => {
  const state = getQuickJoinNameSetupState();

  if (!state?.required || Number(state.userId) !== Number(user?.id)) {
    return;
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    ...state,
    dismissed: true,
  }));
};

export const clearQuickJoinNameSetup = (user) => {
  const state = getQuickJoinNameSetupState();

  if (!state || Number(state.userId) === Number(user?.id)) {
    localStorage.removeItem(STORAGE_KEY);
  }
};
